import React from 'react';
import { useSelector } from 'react-redux';

import {
  defaultSortBy,
  defaultVisibleCols,
  defaultVisibleFacets,
  emptyFilterFlows,
  filterLabelMapping,
  flowsFilters,
} from 'src/constants/flowsListTableDefaults';

import { useFlows } from '../hooks/useFlows';
import { useFlowsListColumns } from '../hooks/useFlowsListColumns.hook';

import { FlowsListPage } from '../pages/FlowsList.page';

import { LoadingPanel } from 'Common/LoadingPanel';
import FilterTable from '../components/filter-table/FilterTable';
import EmptyState from '../components/common/EmptyState/EmptyState';

import type { RootState } from '../types/state.types';

export const FlowsList = () => {
  const pipes = useSelector((state: RootState) => state.pipes);

  const { flows, status: flowsStatus } = useFlows();

  const columns = useFlowsListColumns(pipes);

  if (flowsStatus === 'loading-pipes') {
    return <LoadingPanel loadingMessage="Fetching pipes..." />;
  }

  if (flowsStatus === 'calculating-flows') {
    return <LoadingPanel loadingMessage="Calculating flows" />;
  }

  if (flowsStatus === 'calculating-flows-finished-with-none-flows') {
    return (
      <FlowsListPage>
        <EmptyState>
          <p>No flows (paths between global pipes and systems) were found in this subscription.</p>
          <p>
            To start using this feature, add <code>"global": true</code> to the{' '}
            <code>metadata</code> property in your global pipes.
          </p>
        </EmptyState>
      </FlowsListPage>
    );
  }

  return (
    <FlowsListPage>
      <FilterTable
        defaults={{
          filter: flowsFilters,
          sortBy: defaultSortBy,
          visibleCols: defaultVisibleCols,
          visibleFacets: defaultVisibleFacets,
        }}
        emptyFilter={emptyFilterFlows}
        filterLabelMapping={filterLabelMapping}
        columns={columns}
        itemsToFilter={flows}
        tableKey="flows"
      />
    </FlowsListPage>
  );
};
